import {
  ClockCounterClockwise,
  Envelope,
  Star,
  Tag,
  Users,
} from '@phosphor-icons/react';
import type { AdminTab } from '../../../helpers/adminFilters';

const tabs = [
  { id: 'users', Icon: Users, count: 'users' },
  { id: 'history', Icon: ClockCounterClockwise, count: 'places' },
  { id: 'reviews', Icon: Star, count: 'reviews' },
  { id: 'tags', Icon: Tag, count: 'tags' },
  { id: 'inquiries', Icon: Envelope, count: 'inquiries' },
] as const;

type AdminTabsProps = {
  activeTab: AdminTab;
  counts: Record<string, number>;
  labels: Record<string, string>;
  onChange: (tab: AdminTab) => void;
};

export default function AdminTabs({
  activeTab,
  counts,
  labels,
  onChange,
}: AdminTabsProps) {
  return (
    <div className="admin-tabs">
      {tabs.map(({ id, Icon, count }) => (
        <button
          key={id}
          className={activeTab === id ? 'active' : ''}
          onClick={() => onChange(id)}
        >
          <Icon />
          {labels[id]}
          <span>{counts[count]}</span>
        </button>
      ))}
    </div>
  );
}
